import React from "react";

const DocumentIcon = (props) => {
  const height = props?.height || 20;
  const width = props?.width || 20;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g
        transform="matrix(1.1,0,0,1.1,-1.2,-1.2)"
        fill="currentColor"
      >
        {/* Document body */}
        <path d="M7 2h7l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />

        {/* Folded corner */}
        <path
          d="M14 2v5h5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Text lines */}
        <path
          d="M9 11h6M9 14h6M9 17h4"
          fill="none"
          stroke="#fff"
          strokeWidth="1.2"
          strokeLinecap="round"
          opacity="0.9"
        />
      </g>
    </svg>
  );
};

export default DocumentIcon;